import React, { useState, useEffect } from 'react';
import styles from './TabsComponent.module.css'; 
import { useNavigate } from 'react-router-dom'; 
import { useTranslation } from 'react-i18next';

const TabsComponent = ({ externalTab , setExternalTab,isEditServisePreducer}) => {
  const { t, i18n } = useTranslation();
  const tabs = [
    t('Categories'),
    t('services'),
    t('serviceProvider'),
    t('time')
  ];

  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();

  // Watch for externalTab change and update selectedTab
  useEffect(() => {
    if (externalTab != undefined ) {
      setSelectedTab(externalTab);  
    }
    
  }, [externalTab, selectedTab]);

  const handleTabClick = (index) => {
    if (!isEditServisePreducer && index < selectedTab) {
      setExternalTab(index); 
    }
    if(isEditServisePreducer){
      setExternalTab(2)
    }
  };

  // Navigate based on selected tab
  useEffect(() => {
    if (selectedTab == 0) {
      navigate('/categories');
    } else if (selectedTab == 1) {
      navigate('/services');
    } else if (selectedTab == 2) {
      navigate('/serviceproviders');
    } else if (selectedTab == 3) {
      navigate('/time');
    }
  }, [selectedTab, navigate]);

  return (
    <div className={styles.tabsContainer} style={{ direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
      {tabs.map((tab, index) => (
        <div
          key={index}
          className={`${styles.tab} ${selectedTab === index ? styles.Bigtab : styles.smalltab}`}
          style={{
            backgroundColor: selectedTab === index ? '#B49345' : '#E8E8E8',
            color: selectedTab === index ? '#E8E8E8' : '#333',
            zIndex: selectedTab === index 
            ? 1000 
            : index === selectedTab - 1  ? 1001 : index === selectedTab - 2 
              ? 1002  
              : index === selectedTab - 3 ? 1003 : 99 - index,
            border: selectedTab === index ? '1px solid #B49345' : '1px solid #E8E8E8',
            borderRadius: i18n.language === 'ar' ? '50px 0 0 50px' : '0 50px 50px 0',
          }}
          onClick={() => handleTabClick(index)}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default TabsComponent;
